import SharingLinks from 'contentful/sharing_links';

const EventIntro = ({ title, subTitle, hashtag }) => (
  <section className="event__intro">
    <h1 className="event__title fs-32 m-fs-48 mb-32">{title}</h1>
    {subTitle && (
      <p className="event__sub-title fs-24 fw-600 ff-body lh-1-2 mb-24">
        {subTitle}
      </p>
    )}

    <SharingLinks hashtag={hashtag} className="mb-32 l-mb-46" />
  </section>
);

export default EventIntro;
